import React, { useState } from "react";
import {
  IconCreditCard,
  IconFileText,
  IconFileInvoice,
  IconReceipt,
  IconCoins,
  IconHandStop,
} from "@tabler/icons";
import { Tabs } from "@mantine/core";
import ClientPaymentsTab from "./ClientPaymentsTab";
import CommissionStatementsTab from "./CommissionStatementsTab";
import OrdersTab from "./OrdersTab";
import IncentivesTab from "./IncentivesTab";
import HoldingBidsTab from "./HoldingBidsTab";
import PayrollBidsTab from "./PayrollBidsTab";

const PayrollSearchTabs = ({ form, name }) => {
  const [activeTab, setActiveTab] = useState("clientPayments");
  const [visitedTabs, setVisitedTabs] = useState(new Set(["clientPayments"]));

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setVisitedTabs((prev) => new Set([...prev, tab]));
  };

  const clientPaymentsCount = form?.values?.clientPayments?.length || 0;
  const commissionStatementsCount =
    form?.values?.commissionStatements?.length || 0;
  const debitNotesCount =
    form?.values?.debitNotesFromClientPayments?.length || 0;
  const ordersCount = form?.values?.ordersFromCommissionStatements?.length || 0;
  const incentivesCount = form?.values?.incentives?.length || 0;
  const holdingBidsCount = form?.values?.holdingBidsCount || 0;
  const payrollBidsCount = form?.values?.payrollBidsCount || 0;

  return (
    <Tabs value={activeTab} onTabChange={handleTabChange}>
      <Tabs.List mb="xl">
        <Tabs.Tab
          value="clientPayments"
          icon={<IconCreditCard size={14} color="#40c057" />}
          sx={{
            color: "#40c057 !important",
            "&[data-active]": { color: "#40c057 !important" },
            "&:hover": { color: "#40c057 !important" },
          }}
        >
          Client Payments{" "}
          {clientPaymentsCount > 0 && `(${clientPaymentsCount})`}
        </Tabs.Tab>
        <Tabs.Tab
          value="commissionStatements"
          icon={<IconFileText size={14} color="#40c057" />}
          sx={{
            color: "#40c057 !important",
            "&[data-active]": { color: "#40c057 !important" },
            "&:hover": { color: "#40c057 !important" },
          }}
        >
          Commission Statements{" "}
          {commissionStatementsCount > 0 && `(${commissionStatementsCount})`}
        </Tabs.Tab>
        <Tabs.Tab
          value="orders"
          icon={<IconFileInvoice size={14} color="#fd7e14" />}
          sx={{
            color: "#fd7e14 !important",
            "&[data-active]": { color: "#fd7e14 !important" },
            "&:hover": { color: "#fd7e14 !important" },
          }}
        >
          Orders{" "}
          {(debitNotesCount > 0 || ordersCount > 0) &&
            `(${debitNotesCount + ordersCount})`}
        </Tabs.Tab>
        <Tabs.Tab
          value="incentives"
          icon={<IconReceipt size={14} color="#fd7e14" />}
          sx={{
            color: "#fd7e14 !important",
            "&[data-active]": { color: "#fd7e14 !important" },
            "&:hover": { color: "#fd7e14 !important" },
          }}
        >
          Incentive / Charge {incentivesCount > 0 && `(${incentivesCount})`}
        </Tabs.Tab>
        <Tabs.Tab
          value="holdingBids"
          icon={<IconHandStop size={14} color="#fd7e14" />}
          sx={{
            color: "#fd7e14 !important",
            "&[data-active]": { color: "#fd7e14 !important" },
            "&:hover": { color: "#fd7e14 !important" },
          }}
        >
          Holding Bids {holdingBidsCount > 0 && `(${holdingBidsCount})`}
        </Tabs.Tab>
        <Tabs.Tab
          value="payrollBids"
          icon={<IconCoins size={14} color="#228be6" />}
          sx={{
            color: "#228be6 !important",
            "&[data-active]": { color: "#228be6 !important" },
            "&:hover": { color: "#228be6 !important" },
          }}
        >
          Payroll Bids {payrollBidsCount > 0 && `(${payrollBidsCount})`}
        </Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value="clientPayments" pt="xs">
        {activeTab === "clientPayments" && <ClientPaymentsTab form={form} />}
      </Tabs.Panel>

      <Tabs.Panel value="commissionStatements" pt="xs">
        {activeTab === "commissionStatements" && (
          <CommissionStatementsTab form={form} />
        )}
      </Tabs.Panel>

      <Tabs.Panel value="orders" pt="xs">
        {activeTab === "orders" && <OrdersTab form={form} />}
      </Tabs.Panel>

      <Tabs.Panel value="incentives" pt="xs">
        {activeTab === "incentives" && <IncentivesTab form={form} />}
      </Tabs.Panel>

      <Tabs.Panel value="holdingBids" pt="xs">
        {visitedTabs.has("holdingBids") && <HoldingBidsTab form={form} />}
      </Tabs.Panel>

      <Tabs.Panel value="payrollBids" pt="xs">
        {visitedTabs.has("payrollBids") && <PayrollBidsTab form={form} />}
      </Tabs.Panel>
    </Tabs>
  );
};

export default PayrollSearchTabs;
